import { Link } from 'react-router-dom';
import { useInventariosDoAtivo } from '../hooks';
import { InventoryStatusBadge, InventoryResultBadge } from './InventoryStatusBadge';
import { formatarData } from '../utils/formatters';

interface Props {
  assetId: string;
}

/**
 * Aba "Inventário" no detalhe do ativo — participações do ativo em
 * ações anuais de inventário + resultado + link.
 */
export function InventarioTab({ assetId }: Props) {
  const q = useInventariosDoAtivo(assetId);

  if (q.isLoading) return <p className="py-6 text-center text-sm text-gray-500">Carregando...</p>;
  if (q.isError) return <p className="py-6 text-center text-sm text-red-600">Falha ao carregar inventários.</p>;
  const items = q.data?.data ?? [];
  if (items.length === 0) {
    return <p className="py-6 text-center text-sm text-gray-500">Ativo nunca participou de uma ação anual de inventário.</p>;
  }

  return (
    <table className="min-w-full text-sm">
      <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
        <tr>
          <th className="px-3 py-2 text-left">Ação anual de inventário</th>
          <th className="px-3 py-2 text-left">Status</th>
          <th className="px-3 py-2 text-left">Resultado</th>
          <th className="px-3 py-2 text-left">Conferido em</th>
          <th className="px-3 py-2 text-left">Por</th>
          <th className="px-3 py-2 text-left">Observação</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {items.map((it) => (
          <tr key={it.id}>
            <td className="px-3 py-2 text-gray-800">
              <Link to={`/ativos/inventarios/${it.inventoryId}`} className="text-blue-600 hover:underline">
                {it.inventoryName ?? '—'}
              </Link>
            </td>
            <td className="px-3 py-2">
              {it.inventoryStatus && <InventoryStatusBadge status={it.inventoryStatus as any} />}
            </td>
            <td className="px-3 py-2"><InventoryResultBadge result={it.result} /></td>
            <td className="px-3 py-2 text-gray-700">{it.checkedAt ? formatarData(it.checkedAt) : '—'}</td>
            <td className="px-3 py-2 text-gray-700">{it.checkedByUser?.name ?? (it.checkedAt ? '(auto)' : '—')}</td>
            <td className="px-3 py-2 text-gray-700">{it.divergenceNotes ?? '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
